import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const NotFoundItem = () => {
  const { t } = useTranslation()

  return (
    <Box height="60vh" display="flex" justifyContent="center" alignItems="center" padding={2}>
      <Typography textAlign="center" fontSize="20px" color={'baseColor.colorText1'}>
        {t('errors.notFoundFoodItem')}
      </Typography>
    </Box>
  )
}

export default NotFoundItem
